import Main from '@/views/administracion/contratos/Main.vue';
import Configuracion from './configuracion';
import Default from '@/views/administracion/contratos/Default.vue';
import MainContrato from '@/views/administracion/contratos/contrato/Main.vue';
import DefaultContrato from '@/views/administracion/contratos/contrato/Default.vue';
import MainAnticipos from '@/views/administracion/contratos/contrato/anticipos/Main.vue';
import MainConvenios from '@/views/administracion/contratos/contrato/convenios/Main.vue';
import MainFianzas from '@/views/administracion/contratos/contrato/fianzas/Main.vue';
import MainCatalogo from '@/views/administracion/contratos/contrato/catalogo/Main.vue';
import MainDeducciones from '@//views/administracion/contratos/contrato/deducciones/Main.vue';
import MainSuperintendentes from '@/views/administracion/contratos/contrato/superintendentes/Main.vue';
import MainPrograma from '@/views/administracion/contratos/contrato/programa/Main.vue';
import MainResponsables from '@/views/administracion/contratos/contrato/responsables/Main.vue';
import MainActividades from '@/views/administracion/contratos/contrato/actividades/Main.vue';
import MainExpediente from '@/views/administracion/contratos/contrato/expediente/Main.vue';
import MainContratosRelacionados from '@/views/administracion/contratos/contrato/contratosrelacionados/Main.vue';
import MainEstadisticas from '@/views/administracion/contratos/estadisticas/Main.vue';
import MainFirmas from '@/views/administracion/contratos/contrato/firmas/Main.vue';

const auth = ['Contratos:ver'];
const scopes = ['Contratos:crear', 'Contratos:editar', 'Contratos:eliminar'];

const contratos = [
  {
    path: 'contratos',
    meta: {
      title: '',
      auth,
    },
    component: Main,
    children: [
      {
        name: 'contratosEstadisticas',
        path: 'estadisticas',
        meta: {
          title: 'Contratos Estadisticas',
          auth,
          scopes,
        },
        component: MainEstadisticas,

        children: [],
      },
      ...Configuracion,
      {
        name: 'contratos',
        path: '/',
        meta: {
          title: 'Contratos',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        path: ':idContrato',
        meta: {
          title: 'Contrato',
          auth,
          scopes,
        },
        component: MainContrato,
        children: [
          {
            name: 'contrato',
            path: '/',
            meta: {
              title: 'Contrato',
              auth,
              scopes,
            },
            component: DefaultContrato,
          },
          {
            name: 'contratoAnticipos',
            path: 'anticipos',
            meta: {
              title: 'Contrato anticipos',
              auth,
              scopes,
            },
            component: MainAnticipos,
          },
          {
            name: 'contratoConvenios',
            path: 'convenios',
            meta: {
              title: 'Contrato convenios',
              auth,
              scopes,
            },
            component: MainConvenios,
          },
          {
            name: 'contratoFianzas',
            path: 'fianzas',
            meta: {
              title: 'Fianzas',
              auth,
              scopes,
            },
            component: MainFianzas,
          },
          {
            name: 'contratoCatalogo',
            path: 'catalogo',
            meta: {
              title: 'Contrato catálogo',
              auth,
              scopes,
            },
            component: MainCatalogo,
          },
          {
            name: 'contratoDeducciones',
            path: 'deducciones',
            meta: {
              title: 'Deduccion',
              auth,
              scopes,
            },
            component: MainDeducciones,
          },
          {
            name: 'contratoSuperintendentes',
            path: 'superintendentes',
            meta: {
              title: 'Superintendentes',
              auth,
              scopes,
            },
            component: MainSuperintendentes,
          },
          {
            name: 'contratoPrograma',
            path: 'programa',
            meta: {
              title: 'Programa',
              auth,
              scopes,
            },
            component: MainPrograma,
          },
          {
            name: 'contratoResponsables',
            path: 'responsables',
            meta: {
              title: 'Responsables',
              auth,
              scopes,
            },
            component: MainResponsables,
          },
          {
            name: 'contratoActividades',
            path: 'actividades',
            meta: {
              title: 'Actividades',
              auth,
              scopes,
            },
            component: MainActividades,
          },
          {
            name: 'contratoExpediente',
            path: 'expediente',
            meta: {
              title: 'Expediente',
              auth,
              scopes,
            },
            component: MainExpediente,
          },
          {
            name: 'contratoContratosRelacionados',
            path: 'contratosrelacionados',
            meta: {
              title: 'Contratos Relacionados',
              auth,
              scopes,
            },
            component: MainContratosRelacionados,
          },
          {
            name: 'contratoFirmas',
            path: 'firmas',
            meta: {
              title: 'Firmas',
              auth,
              scopes,
            },
            component: MainFirmas,
          },
        ],
      },
    ],
  },
];

export default contratos;
